import type { Staff } from "@/lib/authv2/store";
import { ACTION } from "@/lib/auth/actions";
import { hasPermission } from "@/lib/authv2/permissions";
import { useKhoFlag } from "./flag";

/** Được xem mục Kho (máy chủ cắt dữ liệu theo vai). */
export function canReadKho(staff: Staff | null): boolean {
  if (!staff) return false;
  return hasPermission(ACTION.KhoRead);
}

/** Cổng menu: có quyền VÀ công tắc KHO_ERP_ENABLED đang bật. */
export function showKhoInMenu(staff: Staff): boolean {
  return canReadKho(staff) && useKhoFlag.getState().enabled;
}

/**
 * Cổng menu "Mượn / trả đồ" (máy quét trong ERP, kho-erp v1.4 §3.2): người
 * gửi được lệnh kho VÀ cả hai công tắc KHO_ERP_ENABLED + KHO_SCANNER_ENABLED.
 * Quyền vào cơ sở do kho kiểm khi quét tờ mã cửa kho.
 */
export function showLoanScannerInMenu(staff: Staff | null): boolean {
  if (!staff) return false;
  const f = useKhoFlag.getState();
  return hasPermission(ACTION.KhoCommand) && f.enabled && f.scanner;
}
